import { Component, EventEmitter, HostListener, Output, signal, AfterViewInit, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Router} from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { UtilService } from 'src/app/shared/helper/util.service';
import { AuthService } from '@auth0/auth0-angular';
import * as _ from 'lodash';
import { AnalyticsService } from './analytics.service';

import { PageTransitionService } from 'src/app/shared/services/pageTransition.service';
import { RequestAccessDialogComponent } from 'src/app/shared/request-access-dialog/request-access-dialog.component';
import { ManageRequestsService } from '../manage-requests/manage-requests.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss'
})

export class AnalyticsComponent implements OnInit, AfterViewInit {

  @ViewChild('pageRoot') pageRoot: ElementRef;
  
  isFilterOpen = false;

  regions = signal(['AIM', 'AMC', 'AMN', 'E2A', 'EUC', 'EUN', 'EUS']);
  businessLines = signal(['AGB', 'URB']);
  functions = signal(['Finance', 'Marketing', 'Sales']);
  categoriesLinked = signal([
    'Descriptive Analysis',
    'Diagnostic Analysis',
    'Predictive Analysis',
    'Prescriptive Analysis'
  ]);
  

  selectedRegions = signal<string[]>([]);
  selectedBusinessLines = signal<string[]>([]);
  selectedFunctions = signal<string[]>([]);
  selectedCategories = signal<string[]>([]);
  selectedProductLines = signal<string[]>([]);
  searchText: any;
  allRegions: any = [];
  allBusinessLines: any = [];
  allFunctions: any = [];
  allProductLines:any = [];
  originalgetinsightsModules: any;
  originalBookmarkgetinsightsModules: any;
  originalMyDashboardInsightsModules: any;
  selectedAnalticsFilters: Subscription;
  bussinessProductLine: any;
  userName: string;
  companyName: any;
  companyId: any;
  stepOneDetails: any;
  
  toggleFiltersCont() : void {
    this.isFilterOpen = !this.isFilterOpen;
  }

  loadedItemsCount = 8
  analyticsProducts:any = [];
  isDropdownOpen = false
  selectedItems: any[] = [];
  moduleByteMap: any;
  userId: string;
  insightsModule: any;
  public insightsData: any;
  insightsModuleRecords: any = [];
  getinsightsModules: any = [];
  id: string = '';
  clearSubscription: Subscription;
  errMsg: any;
  showErrorMessageWithPopup: any = false;
  allCategories: any = []
  allTags: any = []
  isViewMoreVisible = false
  @Output() selectionChange = new EventEmitter<string[]>();
  typeOptions: any = []
  typeDropdownSettings: IDropdownSettings = {};
  filterForm: FormGroup;
  showCategory = false;
  showTags = false;
  allInsightsModulesHeaders:any=[]
  allInsightsModules:any=[]
  selectedFilterType: any = [];
  currentPage=1;
  loadMoreRecord=true;
  headerId=4;
  page: number = 1;           
  limit: number = 10;         
  loading: boolean = false;
  getinsightsModulesHeaders:any=[]
  pageLoadFlag=true
  loadMoreProdcuts:any=true;
  allProdcuts:any=[]
  // pageLimit=10;
  totalResultCount=0
  sortingList: any  = [];
  allSortingList = [
    
    {
      "id": 2,
      "sortBy": 'module_name',
      "sortType": 'asc',
      "label": "Module Name (A - Z)"
    },
    {
      "id": 3,
      "sortBy": 'module_name',
      "sortType": 'desc',
      "label": "Module Name (Z - A)"
    },
    {
      "id": 4,
      "sortBy": 'updated_date',
      "sortType": 'asc',
      "label": "Updated Date (Ascending)"
    },
    {
      "id": 5,
      "sortBy": 'updated_date',
      "sortType": 'desc',
      "label": "Updated Date (Descending)"
    }
  ]
  selectedSort: string = null
  searchTextFlag: any = false;
  subscriptionMsg =
    'Please contact DMINT Administrator to get subscription of the same';
  closeSign: string;
  successMessage: any;
  isUserLoggedIn: boolean;
  selectedAnalyticsTab = 'All Dashboards'
  constructor(
    private spinnerService: NgxSpinnerService,
    private homePageService: HomePageService,
    private utilService: UtilService,
    private auth: AuthService,
    private analyticService: AnalyticsService,
    private fb: FormBuilder,
    public router: Router,
    private pageTransition: PageTransitionService,
    private manageRequestService: ManageRequestsService,
    private dialog: MatDialog
  ) { 
  }

  isLoading = true
  private loadStartTime: number;

  ngAfterViewInit() { 
    this.pageLoaded();
  }

  pageLoaded() {
    const minDelay = 1600; // 1.6 seconds
    const elapsed = Date.now() - this.loadStartTime;
    const remaining = Math.max(0, minDelay - elapsed);

    setTimeout(() => {
      this.isLoading = false;
      if (this.pageRoot?.nativeElement) {
        this.pageTransition.fadeIn(this.pageRoot.nativeElement);
      }
    }, remaining);
  }

  setNewlyAddedSorting(){
  let newlyAddedSortObj = {
      "id": 1,
      "sortBy": 'created_date',
      "sortType": 'desc',
      "label": "Newly Added"
  }
  this.sortingList = [newlyAddedSortObj,...this.allSortingList];
  }
  
  ngOnInit(): void {
        this.utilService.getHeaderId.subscribe((res:any) => this.headerId = res || this.headerId  );
    this.userDetails();
    this.initForm()
    this.sortingList = [...this.allSortingList];
    this.spinnerService.show();
    this.utilService.goToTop();      

    this.utilService.moduleBytes.subscribe((mod) => {
      this.moduleByteMap = mod as Object;
    });
    this.utilService.getUserId.subscribe((userId: any) => {
      this.userId = userId;

      this.isUserLoggedIn =  this.utilService.isUserLoggedIn();

      this.homePageService.onHeader(this.userId).subscribe((res) => {
        this.spinnerService.hide();
        this.insightsModule = res;
        if (this.insightsModule.message === 'OK') {
          this.insightsData = this.insightsModule.result;
          this.insightsModuleRecords = [...this.insightsData];
          for (let modulerecord of this.insightsModuleRecords) {
            if (modulerecord.id == this.headerId ) {
              this.getinsightsModulesHeaders = modulerecord.modules;
              this.getinsightsModulesHeaders.forEach((item:any)=>{
                item['moduleTypeName']=item.moduleType.moduleTypeName;
              })
              this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);
              this.getAllAnalyticsModules(true)
              
            }
          }
        }
      });
    });
    if (localStorage.getItem('userId')) {
      this.id = localStorage.getItem('userId');
    }

    this.getAllRegions();
    this.getAllBusinessLines();
    this.getAllFunctions();
    this.getAllCategories();
    this.getAllProductLines();

    this.clearSubscription = this.utilService.SharingDataPopUpMessage.subscribe(
      (res: any) => {
        this.spinnerService.hide();
        this.errMsg = res;
      }
    );
    this.clearSubscription = this.utilService.getPopupStatus.subscribe(
      (res: any) => {
        this.spinnerService.hide();
        this.showErrorMessageWithPopup = res;
      }
    );
    this.utilService.SharingDataPopUpMessage.subscribe((res: any) => {
      this.spinnerService.hide();
      this.errMsg = res;
    });
    this.utilService.getPopupStatus.subscribe((res: any) => {
      this.spinnerService.hide();

      if (this.errMsg !== null) {
        this.showErrorMessageWithPopup = res;
      }
    });
    this.getSelectedFiltersSubscription();
  }
  initForm() {
    this.filterForm = this.fb.group({
    //  search: [''],
      typeList: this.fb.array([]),
      tags: this.fb.array([]),
    
      regionsList: this.fb.array([]),
      businessLinesList: this.fb.array([]),
      functionsList: this.fb.array([]),
      categoryList: this.fb.array([]),
      productLinesList: this.fb.array([]),
      sortBy: ['created_date'],
      sortType: ['desc'],
    })
  }
  getSelectedFiltersSubscription(){
    this.selectedAnalticsFilters = this.utilService.shareSelectedAnalyticsFilters.subscribe(
      (res: any) => {
        const applyFilters = () => {
          if (res?.regionsList) {
            const regionsArray = this.filterForm.get('regionsList') as FormArray;
            regionsArray.clear();
            this.allRegions.forEach((region: any) => region.selected = false);
            res.regionsList.forEach((regionId: any) => {
              regionsArray.push(this.fb.control(regionId));
              const regionIndex = this.allRegions.findIndex((r: any) => r.regionId === regionId);
              if (regionIndex > -1) {
                this.allRegions[regionIndex]['selected'] = true;
              }
            });
            const selectedRegionIds = res.regionsList;
            const selectedRegionNames = this.allRegions
              .filter((region: any) => selectedRegionIds.includes(region.regionId))
              .map((region: any) => region.regionName);
            this.selectedRegions.set(selectedRegionNames);
          }
          if (res?.businessLinesList) {
            const businessLinesArray = this.filterForm.get('businessLinesList') as FormArray;
            businessLinesArray.clear();
            this.allBusinessLines.forEach((bl: any) => bl.selected = false);
            res.businessLinesList.forEach((businessLineId: any) => {
            businessLinesArray.push(this.fb.control(businessLineId));
            const blIndex = this.allBusinessLines.findIndex((bl: any) => bl.businessLineId === businessLineId);
            if (blIndex > -1) {
              this.allBusinessLines[blIndex]['selected'] = true;
            }
            });
            const selectedBusinessLineIds = res.businessLinesList;
            const selectedBusinessLineNames = this.allBusinessLines
            .filter((bl: any) => selectedBusinessLineIds.includes(bl.businessLineId))
            .map((bl: any) => bl.businessLineName);
            this.selectedBusinessLines.set(selectedBusinessLineNames);
          }
          if (res?.functionsList) {
            const functionsArray = this.filterForm.get('functionsList') as FormArray;
            functionsArray.clear();
            this.allFunctions.forEach((fn: any) => fn.selected = false);
            res.functionsList.forEach((functionId: any) => {
            functionsArray.push(this.fb.control(functionId));
            const fnIndex = this.allFunctions.findIndex((fn: any) => fn.functionId === functionId);
            if (fnIndex > -1) {
              this.allFunctions[fnIndex]['selected'] = true;
            }
            });
            const selectedFunctionIds = res.functionsList;
            const selectedFunctionNames = this.allFunctions
            .filter((fn: any) => selectedFunctionIds.includes(fn.functionId))
            .map((fn: any) => fn.functionName);
            this.selectedFunctions.set(selectedFunctionNames);
          }
            if (res?.productLinesList) {
            const productLinesArray = this.filterForm.get('productLinesList') as FormArray;
            productLinesArray.clear();
            this.allProductLines.forEach((pl: any) => pl.selected = false);
            res.productLinesList.forEach((productLineId: any) => {
            productLinesArray.push(this.fb.control(productLineId));
            const plIndex = this.allProductLines.findIndex((pl: any) => pl.productLineId === productLineId);
            if (plIndex > -1) {
              this.allProductLines[plIndex]['selected'] = true;
            }
            });
            const selectedProductLineIds = res.productLinesList;
            const selectedProductLineNames = this.allProductLines
            .filter((pl: any) => selectedProductLineIds.includes(pl.productLineId))
            .map((pl: any) => pl.productLineName);
            this.selectedProductLines.set(selectedProductLineNames);
          }
          if (res?.categoryList) {
            const categoryArray = this.filterForm.get('categoryList') as FormArray;
            categoryArray.clear();
            this.allCategories.forEach((cat: any) => cat.selected = false);
            res.categoryList.forEach((categoryId: any) => {
            categoryArray.push(this.fb.control(categoryId));
            const catIndex = this.allCategories.findIndex((cat: any) => cat.categoryId === categoryId);
            if (catIndex > -1) {
              this.allCategories[catIndex]['selected'] = true;
            }
            });
            const selectedCategoryIds = res.categoryList;
            const selectedCategoryNames = this.allCategories
            .filter((cat: any) => selectedCategoryIds.includes(cat.categoryId))
            .map((cat: any) => cat.categoryName);
            this.selectedCategories.set(selectedCategoryNames);
          }

          if(res?.searchText){
            this.searchText= res.searchText;
          }

          if(res?.selectedTab){
            this.selectedTab = signal<'All Dashboards' | 'My Dashboards' | 'Bookmarks'>(res.selectedTab);
            this.selectedAnalyticsTab = res.selectedTab;
            this.onTabChange()
          } 
          this.getAllAnalyticsModules(true);
        };

          const loadAndApplyFilters = () => {
          let regionsLoaded = !!this.allRegions && this.allRegions.length > 0;
          let businessLinesLoaded = !!this.allBusinessLines && this.allBusinessLines.length > 0;
          let functionsLoaded = !!this.allFunctions && this.allFunctions.length > 0;
          let productLinesLoaded = !!this.allProductLines && this.allProductLines.length > 0;
          let categoriesLoaded = !!this.allCategories && this.allCategories.length > 0; 
          let loaders = [];

          if (!regionsLoaded) {
            loaders.push(
            this.analyticService.getAllRegions().toPromise().then((resRegions: any) => {
              this.allRegions = resRegions.result || [];
              if (this.allRegions?.length > 0) {
              this.allRegions.forEach((ele: any) => {
                ele['selected'] = false;
              });
              }
            })
            );
          }
          if (!businessLinesLoaded) {
            loaders.push(
            this.analyticService.getAllBusinessLines().toPromise().then((resBL: any) => {
              this.allBusinessLines = resBL.result || [];
              if (this.allBusinessLines?.length > 0) {
              this.allBusinessLines.forEach((ele: any) => {
                ele['selected'] = false;
              });
              }
            })
            );
          }
          if (!functionsLoaded) {
            loaders.push(
            this.analyticService.getFunctions().toPromise().then((resFn: any) => {
              this.allFunctions = resFn.result || [];
              if (this.allFunctions?.length > 0) {
              this.allFunctions.forEach((ele: any) => {
                ele['selected'] = false;
              });
              }
            })
            );
          }
          if (!productLinesLoaded) {
            loaders.push(
            this.analyticService.getProductLines().toPromise().then((resPL: any) => {
              this.allProductLines = resPL.result || [];
              if (this.allProductLines?.length > 0) {
              this.allProductLines.forEach((ele: any) => {
                ele['selected'] = false;
              });
              }
            })
            );
          }
        
          if (!categoriesLoaded) {
            loaders.push(
            this.analyticService.getAllCategories().toPromise().then((resCat: any) => {
              this.allCategories = resCat.result || [];
              if (this.allCategories?.length > 0) {
              this.allCategories.forEach((ele: any) => {
                ele['selected'] = false;
              });
              }
            })
            );
          }

          if (loaders.length > 0) {
            Promise.all(loaders).then(() => {
            applyFilters();
            });
          } else {
            applyFilters();
          }
          };

          loadAndApplyFilters();
      }
      
      
    );
  }
  get typeList() {
    return this.filterForm.get('typeList') as FormArray;
  }

  get categoryList() {
    return this.filterForm.get('categoryList') as FormArray;
  }

  get tags() {
    return this.filterForm.get('tags') as FormArray;
  }

  get regionsList() {
    return this.filterForm.get('regionsList') as FormArray;
  }

  get businessLinesList() {
    return this.filterForm.get('businessLinesList') as FormArray;
  }

  get productLinesList() {
    return this.filterForm.get('productLinesList') as FormArray;
  }

  get functionsList() {
    return this.filterForm.get('functionsList') as FormArray;
  }

  isCategorySelected(categoryName: string): boolean {
    
    return this.categoryList.controls.some((control: any) => control.value === categoryName);
  }

  isTagSelected(tagName: string): boolean {
    return this.tags.controls.some((control: any) => control.value === tagName);
  }

  @HostListener('window:scroll', [])

  onScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      this.loadMoreItems();
    }
  }
  // getAllTags() {
  //   this.analyticService.getAllTags().subscribe((res: any) => {      
  //     this.allTags = res.result
  //     if (this.allTags?.length > 0) {
  //       this.allTags.forEach((ele: any) => {
  //         ele['selected'] = false;
  //       });
  //     }
  //   })
  // }

  getAllModules() {
    this.analyticService.getAllModules().subscribe((res: any) => {
      this.typeOptions = res.result      
    })
  }

  getAllCategories() {
    this.analyticService.getAllCategories().subscribe((res: any) => {      
      this.allCategories = res.result
      if (this.allCategories?.length > 0) {
        this.allCategories.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

  getAllRegions() {
    this.analyticService.getAllRegions().subscribe((res: any) => {      
      this.allRegions = res.result
      if (this.allRegions?.length > 0) {
        this.allRegions.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

  getAllBusinessLines() {
    this.analyticService.getAllBusinessLines().subscribe((res: any) => {      
      this.allBusinessLines = res.result
      if (this.allBusinessLines?.length > 0) {
        this.allBusinessLines.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

  getAllFunctions() {
    this.analyticService.getFunctions().subscribe((res: any) => {      
      this.allFunctions = res.result
      if (this.allFunctions?.length > 0) {
        this.allFunctions.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

  getAllProductLines() {
    this.analyticService.getProductLines().subscribe((res: any) => {      
      this.allProductLines = res.result
      if (this.allProductLines?.length > 0) {
        this.allProductLines.forEach((ele: any) => {
          ele['selected'] = false;
        });
      }
    })
  }

  getAllAnalyticsModules(flag=false) {
      this.fetchProducts(flag) 
  }

  fetchProducts(flag:any){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      "userId":userId,
      "headerId": this.headerId,
      "searchText": this.searchText,
      "categoryIds": this.filterForm?.get('categoryList').value?.length > 0 ? this.filterForm?.get('categoryList').value : null,
      "regionIds": this.filterForm?.get('regionsList').value?.length > 0 ? this.filterForm?.get('regionsList').value : null,
      "businessLineIds": this.filterForm?.get('businessLinesList').value?.length > 0 ? this.filterForm?.get('businessLinesList').value : null,
      "functionIds": this.filterForm?.get('functionsList').value?.length > 0 ? this.filterForm?.get('functionsList').value : null,
      "productLineIds": this.filterForm?.get('productLinesList').value?.length > 0 ? this.filterForm?.get('productLinesList').value : null,
      "sortBy": this.filterForm?.get('sortBy').value,
      "sortType": this.filterForm?.get('sortType').value,
      "limit": 500,
      "page": this.currentPage
    }
    this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
      {
        next: (res: any) => {
          this.spinnerService.hide();
          this.loadMoreRecord = false
          this.getinsightsModules = res.result
          this.totalResultCount=res.totalCount;
          if (this.getinsightsModules?.length > 0 ) {
            this.getinsightsModules.forEach((ele: any) => {
              let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
              if (index > -1) {
                ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                ele.isSingleUserGroup = this.allInsightsModulesHeaders[index].userGroups?.length==1;
                ele.userGroups = this.allInsightsModulesHeaders[index].userGroups;
              }
            })
                       
            if (flag) {
              this.allProdcuts = []
              this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
              this.getinsightsModules = _.cloneDeep(this.allProdcuts);
              let hasNewlyAddedModule = this.getinsightsModules.some((item:any) => item.newlyAdded == true);
              if(hasNewlyAddedModule) this.setNewlyAddedSorting();
              this.originalMyDashboardInsightsModules=this.getinsightsModules;
              this.originalBookmarkgetinsightsModules=this.getinsightsModules;
            }
          } 
         },
        error: (err) => {
          this.spinnerService.hide()
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res
          })
          this.showErrorMessageWithPopup = true;
          setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
        }
      }
    )
  }

  onTabChange(){
  //  this.searchText='';
    if(this.selectedAnalyticsTab=='All Dashboards'){
      this.getAllAnalyticsModules()
    }else if(this.selectedAnalyticsTab=='My Dashboards'){
      this.getMyAnalyticsData()
    }else if(this.selectedAnalyticsTab=='Bookmarks'){
      this.getBoookmarksAnalyticsData()
    }else{
      this.getAllAnalyticsModules()
    }
  }

  getHeader(){
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.insightsModule = res;
      if (this.insightsModule.message === 'OK') {
        this.insightsData = this.insightsModule.result;
        this.insightsModuleRecords = [...this.insightsData];
        this.getUpdatedAnalyticsData()
        }
    });
  }

  onCategoryCheckboxChange(event: any, category: any, flag = false) {
    if (flag) {
      if (category?.categoryId == undefined) {
        const found = this.allCategories?.find((item: any) => item?.categoryName === category);
        if (found) {
          category = found;
        }
      }
      let index = this.allCategories?.findIndex((item: any) => item?.categoryId == category?.categoryId);
      if (index > -1) {
        this.allCategories[index]['selected'] = !this.allCategories[index]['selected']
        if (this.allCategories[index]['selected']) {
          this.categoryList.push(this.fb.control(category.categoryId));
        } else {
          const index = this.categoryList.controls.findIndex((x:any) => x.value === category.categoryId);
          if (index >= 0) {
            this.categoryList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.categoryList.push(this.fb.control(category.categoryId));
      } else {
        const index = this.categoryList.controls.findIndex((x:any) => x.value === category.categoryId);
        if (index >= 0) {
          this.categoryList.removeAt(index);
        }
      }
    }
    //  this.setCurrentPage()
    // this.resetPageLimit()
    const selectedCategoryIds = this.categoryList.value;
    const selectedCategoryNames = this.allCategories
      .filter((cat: any) => selectedCategoryIds.includes(cat.categoryId))
      .map((cat: any) => cat.categoryName);

    this.selectedCategories.set(selectedCategoryNames);
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }

  onRegionCheckboxChange(event: any, region: any, flag = false) {
    if (flag) {
      if (region?.regionId == undefined) {
        const found = this.allRegions?.find((item: any) => item?.regionName === region);
        if (found) {
          region = found;
        }
      }
      let index = this.allRegions?.findIndex((item: any) => item?.regionId == region?.regionId);
      if (index > -1) {
        this.allRegions[index]['selected'] = !this.allRegions[index]['selected']
        if (this.allRegions[index]['selected']) {
          this.regionsList.push(this.fb.control(region.regionId));
        } else {
          const index = this.regionsList.controls.findIndex((x:any) => x.value === region.regionId);
          if (index >= 0) {
            this.regionsList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.regionsList.push(this.fb.control( region.regionId));
      } else {
        const index = this.regionsList.controls.findIndex((x:any) => x.value ===  region.regionId);
        if (index >= 0) {
          this.regionsList.removeAt(index);
        }
      }
    }
    //  this.setCurrentPage()
    // this.resetPageLimit()
    const selectedRegionIds = this.regionsList.value;
    const selectedRegionNames = this.allRegions
      .filter((region: any) => selectedRegionIds.includes(region.regionId))
      .map((region: any) => region.regionName);
    this.selectedRegions.set(selectedRegionNames);
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }

  onBusinessLinesCheckboxChange(event: any, buinessLine: any, flag = false) {
    if (flag) {
       if (buinessLine?.businessLineId == undefined) {
        const found = this.allBusinessLines?.find((item: any) => item?.businessLineName === buinessLine);
        if (found) {
          buinessLine = found;
        }
      }
      let index = this.allBusinessLines?.findIndex((item: any) => item?.businessLineId == buinessLine?.businessLineId);
      if (index > -1) {
        this.allBusinessLines[index]['selected'] = !this.allBusinessLines[index]['selected']
        if (this.allBusinessLines[index]['selected']) {
          this.businessLinesList.push(this.fb.control(buinessLine.businessLineId));
        } else {
          const index = this.businessLinesList.controls.findIndex((x:any) => x.value === buinessLine.businessLineId);
          if (index >= 0) {
            this.businessLinesList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.businessLinesList.push(this.fb.control(buinessLine.businessLineId));
      } else {
        const index = this.businessLinesList.controls.findIndex((x:any) => x.value ===  buinessLine.businessLineId);
        if (index >= 0) {
          this.businessLinesList.removeAt(index);
        }
      }
    }
    //  this.setCurrentPage()
    // this.resetPageLimit()
    const selectedBusinessLinesIds = this.businessLinesList.value;
    const selectedBusinessLinesNames = this.allBusinessLines
      .filter((buinessLine: any) => selectedBusinessLinesIds.includes(buinessLine.businessLineId))
      .map((buinessLine: any) => buinessLine.businessLineName);
    this.selectedBusinessLines.set(selectedBusinessLinesNames);
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }

  onFunctionsCheckboxChange(event: any, functions: any, flag = false) {
    if (flag) {
      if (functions?.functionId == undefined) {
        const found = this.allFunctions?.find((item: any) => item?.functionName === functions);
        if (found) {
          functions = found;
        }
      }
      let index = this.allFunctions?.findIndex((item: any) => item?.functionId == functions?.functionId);
      if (index > -1) {
        this.allFunctions[index]['selected'] = !this.allFunctions[index]['selected']
        if (this.allFunctions[index]['selected']) {
          this.functionsList.push(this.fb.control(functions.functionId));
        } else {
          const index = this.functionsList.controls.findIndex((x:any) => x.value === functions.functionId);
          if (index >= 0) {
            this.functionsList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.functionsList.push(this.fb.control(functions.functionId));
      } else {
        const index = this.functionsList.controls.findIndex((x:any) => x.value ===  functions.functionId);
        if (index >= 0) {
          this.functionsList.removeAt(index);
        }
      }
    }
    //  this.setCurrentPage()
    // this.resetPageLimit()
    const selectedFunctionIds = this.functionsList.value;
    const selectedFunctionNames = this.allFunctions
      .filter((value: any) => selectedFunctionIds.includes(value.functionId))
      .map((value: any) => value.functionName);
    this.selectedFunctions.set(selectedFunctionNames);
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }

  onProductLinesCheckboxChange(event: any, productLine: any, flag = false) {
    if (flag) {
       if (productLine?.productLineId == undefined) {
        const found = this.allProductLines?.find((item: any) => item?.productLineName === productLine);
        if (found) {
          productLine = found;
        }
      }
      let index = this.allProductLines?.findIndex((item: any) => item?.productLineId == productLine?.productLineId);
      if (index > -1) {
        this.allProductLines[index]['selected'] = !this.allProductLines[index]['selected']
        if (this.allProductLines[index]['selected']) {
          this.productLinesList.push(this.fb.control(productLine.productLineId));
        } else {
          const index = this.productLinesList.controls.findIndex((x:any) => x.value === productLine.productLineId);
          if (index >= 0) {
            this.productLinesList.removeAt(index);
          }
        }
      }
    } else {
      if (event.target.checked) {
        this.productLinesList.push(this.fb.control(productLine.productLineId));
      } else {
        const index = this.productLinesList.controls.findIndex((x:any) => x.value ===  productLine.productLineId);
        if (index >= 0) {
          this.productLinesList.removeAt(index);
        }
      }
    }
    //  this.setCurrentPage()
    // this.resetPageLimit()
    const selectedProductLinesIds = this.productLinesList.value;
    const selectedProductLinesNames = this.allProductLines
      .filter((value: any) => selectedProductLinesIds.includes(value.productLineId))
      .map((value: any) => value.productLineName);
    this.selectedProductLines.set(selectedProductLinesNames);
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }

  getUpdatedAnalyticsData(flag=false){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      "userId":userId,
      "headerId":this.headerId,
      "searchText": this.searchText,
      "categoryIds": this.filterForm?.get('categoryList').value?.length > 0 ? this.filterForm?.get('categoryList').value : null,
      "regionIds": this.filterForm?.get('regionsList').value?.length > 0 ? this.filterForm?.get('regionsList').value : null,
      "businessLineIds": this.filterForm?.get('businessLinesList').value?.length > 0 ? this.filterForm?.get('businessLinesList').value : null,
      "functionIds": this.filterForm?.get('functionsList').value?.length > 0 ? this.filterForm?.get('functionsList').value : null,
      "productLineIds": this.filterForm?.get('productLinesList').value?.length > 0 ? this.filterForm?.get('productLinesList').value : null,
      "sortBy": this.filterForm?.get('sortBy').value,
      "sortType": this.filterForm?.get('sortType').value,
      "limit": 500,
      "page": this.currentPage
    }
    this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
      {
        next: (res: any) => {
          this.spinnerService.hide();
          this.loadMoreRecord = false
            this.getinsightsModules = res.result;
            this.totalResultCount=res.totalCount;
            for (let modulerecord of this.insightsModuleRecords) {
              if (modulerecord.headerName == 'Analytics') {
                this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
              }         
            }
            if (this.getinsightsModules?.length > 0 ) {
              this.getinsightsModules.forEach((ele: any) => {
                let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                if (index > -1) {
                  ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                  ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                  ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                  ele.isSingleUserGroup = this.allInsightsModulesHeaders[index].userGroups?.length==1;
                  ele.userGroups = this.allInsightsModulesHeaders[index].userGroups;
                }
              })
              
              if (flag) {
                this.allProdcuts = []
                this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
             
              }
            } else {
              this.loadMoreProdcuts = false
              this.getinsightsModules = _.cloneDeep(this.allProdcuts);
          }
            this.originalBookmarkgetinsightsModules = this.getinsightsModules;
        },
        error: (err) => {
          this.spinnerService.hide()
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res
          })
          this.showErrorMessageWithPopup = true;
          setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
        }
      }
    )
  }

  getMyAnalyticsData(flag=false){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      "userId":userId,
      "headerId":  this.headerId,
      "searchText": this.searchText,
      "categoryIds":  null,
      "regionIds":  null,
      "businessLineIds":  null,
      "functionIds":  null,
      "productLineIds":  null,
      "sortBy": this.filterForm?.get('sortBy').value,
      "sortType": this.filterForm?.get('sortType').value,
      "limit": 500,
      "page": this.currentPage
    }
    this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
      {
        next: (res: any) => {
          this.spinnerService.hide();
          this.loadMoreRecord = false
            let getinsightsModules = res.result;
            this.originalMyDashboardInsightsModules = getinsightsModules
           
            this.totalResultCount=res.totalCount;
            for (let modulerecord of this.insightsModuleRecords) {
              if (modulerecord.headerName == 'Analytics') {
                this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
              }         
            }
            if (getinsightsModules?.length > 0 ) {
              getinsightsModules.forEach((ele: any) => {
                let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                if (index > -1) {
                  ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                  ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                  ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                  ele.isSingleUserGroup = this.allInsightsModulesHeaders[index].userGroups?.length==1;
                  ele.userGroups = this.allInsightsModulesHeaders[index].userGroups;
                }
              })
              } 
          },
        error: (err) => {
          this.spinnerService.hide()
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res
          })
          this.showErrorMessageWithPopup = true;
          setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
        }
      }
    )
  }

  getBoookmarksAnalyticsData(flag=false){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      "userId":userId,
      "headerId":  this.headerId,
      "searchText": this.searchText,
      "categoryIds":  null,
      "regionIds":  null,
      "businessLineIds":  null,
      "functionIds":  null,
      "productLineIds":  null,
      "sortBy": this.filterForm?.get('sortBy').value,
      "sortType": this.filterForm?.get('sortType').value,
      "limit": 500,
      "page": this.currentPage
    }
    this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
      {
        next: (res: any) => {
          this.spinnerService.hide();
          this.loadMoreRecord = false
            let getinsightsModules = res.result;
            this.originalBookmarkgetinsightsModules = getinsightsModules;
           
            this.totalResultCount=res.totalCount;
            for (let modulerecord of this.insightsModuleRecords) {
              if (modulerecord.headerName == 'Analytics') {
                this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
              }         
            }
            if (getinsightsModules?.length > 0 ) {
              getinsightsModules.forEach((ele: any) => {
                let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                if (index > -1) {
                  ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                  ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                  ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                  ele.isSingleUserGroup = this.allInsightsModulesHeaders[index].userGroups?.length==1;
                  ele.userGroups = this.allInsightsModulesHeaders[index].userGroups;
                }
              })
              if (flag) {
                this.allProdcuts = []
                this.allProdcuts = [...this.allProdcuts, ...getinsightsModules];
                getinsightsModules = _.cloneDeep(this.allProdcuts);
                this.originalMyDashboardInsightsModules = getinsightsModules
              }
            } else {
              this.loadMoreProdcuts = false
          }
        },
        error: (err) => {
          this.spinnerService.hide()
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res
          })
          this.showErrorMessageWithPopup = true;
          setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
        }
      }
    )
  }
  
  loadMoreItems() {
    const totalItems = this.analyticsProducts.length;
    if (this.loadedItemsCount < totalItems) {
      this.loadedItemsCount += 8;
    }
  }

  showOptions() {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  clearSelection() {
    this.selectedItems = [];
    this.selectionChange.emit(this.selectedItems);
    this.isDropdownOpen = !this.isDropdownOpen;
    this.loadedItemsCount = 8; 
  }

  ////// Search feature for table starts

  searchTerm = signal('')

  selectedTab = signal<'All Dashboards' | 'My Dashboards' | 'Bookmarks'>('All Dashboards');
  
  get currentSet() {
    return this.analyticsProducts;
  }

  get itemCount() {
    return this.currentSet.length;
  }
  get filteredItems() {
    const selectedOption = this.typeOptions.find((option: any) =>
      this.selectedItems.includes(option.id)
  );

    const filtered = this.analyticsProducts.filter((product:any) => {
      const matchesSearchTerm = product.name
        .toLowerCase()
        .includes(this.searchTerm().toLowerCase());

      const matchesDropdown =
        !selectedOption ||
        selectedOption.id === 0 ||
        selectedOption.isDashboard === product.isDashboard;

      return matchesSearchTerm && matchesDropdown;
    });

    return filtered.slice(0, this.loadedItemsCount);
  }

  allDashboardCount(){ 
    return this.getinsightsModules?.length || 0
  }

  myDashboardCount() {
    return this.originalMyDashboardInsightsModules?.filter((p: any) => p.subscription === true || p.accessCompleted === false).length
  }

  bookmarkedCount() {
    return this.originalBookmarkgetinsightsModules?.filter((p:any) => p.favorite).length
  }
   filterDashboard() {
    let filteredModules = [];
    if (this.selectedAnalyticsTab === 'My Dashboards') {
      filteredModules = this.originalMyDashboardInsightsModules.filter(
        (item: any) => item.subscription === true || item.accessCompleted === false
      );
    } else if (this.selectedAnalyticsTab === 'Bookmarks') {
      filteredModules = this.originalBookmarkgetinsightsModules.filter((item: any) => item.favorite === true);
    } else {
      filteredModules = this.getinsightsModules;
    }
    this.analyticsProducts = filteredModules;
    return filteredModules;
  }

 
  resetAllFilters() {
    this.selectedRegions.set([]);
    this.selectedBusinessLines.set([]);
    this.selectedFunctions.set([]);
    this.selectedCategories.set([]);
    this.selectedProductLines.set([]);
    this.allRegions.forEach((item:any)=>{
      item['selected']=false;
    })
    this.allBusinessLines.forEach((item:any)=>{
      item['selected']=false;
    })
    this.allFunctions.forEach((item:any)=>{
      item['selected']=false;
    })
     this.allCategories.forEach((item:any)=>{
      item['selected']=false;
    })
    this.allProductLines.forEach((item:any)=>{
      item['selected']=false;
    })
    this.regionsList.clear();
    this.businessLinesList.clear();
    this.functionsList.clear();
    this.categoryList.clear();
    this.productLinesList.clear();
    this.utilService.goToTop();
  //  this.setCurrentPage()
  // this.resetPageLimit()
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules();
  }
  
 
  ////// Search feature for table ends

  // Filter using filters starts
  sortAnalytics(item: any ) {
    this.selectedSort = item.label;
    this.isSortingOpen = false;
    this.filterForm.get('sortBy').setValue(item.sortBy)
    this.filterForm.get('sortType').setValue(item.sortType)
  //  this.setCurrentPage()
  // this.resetPageLimit()
   this.loadMoreProdcuts=true
   this.checkFiltersApplied()
   this.getAllAnalyticsModules()
  }
   checkFiltersApplied() {
    this.pageLoadFlag=false;
    if (
      this.filterForm.get('search')?.value != '' ||
      this.filterForm.get('regionsList')?.value?.length > 0 ||
      this.filterForm.get('businessLinesList')?.value?.length > 0 ||
      this.filterForm.get('functionsList')?.value?.length > 0 ||
      this.filterForm.get('productLinesList')?.value?.length > 0 ||
      this.filterForm.get('categoryList')?.value?.length > 0
    ) {
      this.allProdcuts=[]
    }
  }
    clearSearch() {
    this.filterForm.get('search').setValue('')
    this.searchTextFlag=false;
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
    this.utilService.goToTop();
  }
   filterAnalytics() {    
    if(this.searchText!=''){
      this.searchTextFlag=true
    }else{
      this.searchTextFlag=false
    }
  //  this.setCurrentPage()
  // this.resetPageLimit()
   
 
  if(this.selectedAnalyticsTab=='All Dashboards'){
    this.loadMoreProdcuts=true
    this.checkFiltersApplied()
    this.getAllAnalyticsModules()
  }if(this.selectedAnalyticsTab=='My Dashboards'){
    this.loadMoreProdcuts=true
    this.getMyAnalyticsData()
  }if(this.selectedAnalyticsTab=='Bookmarks'){
    this.loadMoreProdcuts=true
   this.getBoookmarksAnalyticsData()
  }
  }

  isSortingOpen = false

  showSorting() {
    this.isSortingOpen = !this.isSortingOpen
  }
  
  sortByRecentlyUpdated() {
    this.isSortingOpen = !this.isSortingOpen;
    return this.currentSet.sort((a:any, b:any) => {
      const dateA = new Date(a.lastUpdated.split("-").reverse().join("-")).getTime();
      const dateB = new Date(b.lastUpdated.split("-").reverse().join("-")).getTime();
      return dateB - dateA;
    });
  }
  sortByRecentlyAdded() {
    this.isSortingOpen = !this.isSortingOpen;
    return this.currentSet.sort((a:any, b:any) => {
      const dateA = new Date(a.createdOn.split("-").reverse().join("-")).getTime();
      const dateB = new Date(b.createdOn.split("-").reverse().join("-")).getTime();
      this.isSortingOpen = !this.isSortingOpen;
      return dateB - dateA;
    });
  }

  sortByFav() {
    this.isSortingOpen = !this.isSortingOpen;
    return this.currentSet.sort()
  }

  openedCard: any = null;

  openPopup(product: any): void {
    this.openedCard = product;
  }

  closeProductPopup() {
    this.openedCard = null;
  }
 toggleFavourite(module:any): void {
    module.favorite = !module.favorite;
    let reqBody = {
        "userId": this.userId,
        "moduleId": module.id||module.moduleId,
        "isFavourite": module.favorite
    }
    this.markUnmarkFavourite(reqBody);
  }
  markUnmarkFavourite(reqBody:any){
    this.analyticService.markUnmarkFavourite(reqBody).subscribe((response: any) => {      
      if(response.code == 200){
        this.successMessage = response.result;
        if(this.userId) this.getHeader()
        setTimeout(() => { this.successMessage = false; this.successMessage = ''; }, 3000)
      }
    })
  }
    onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }

  onSignIn() {
    this.utilService.onSignIn();
  }


  onInsightsApicall(id: any, moduleLink: any,moduleInfo:any) {
    this.spinnerService.hide();
    window.open(`${moduleLink}`, '_blank');
  }
  onSubscribe() { 
    this.errMsg = this.subscriptionMsg;
      this.closeSign = 'OK';
      this.showErrorMessageWithPopup = true;
  }
  viewMore(moduleId: any) {
    this.isViewMoreVisible = true

  }
  onViewMoreClose() {
    this.isViewMoreVisible = false
  }
viewDetails(analyticsProduct: any) {
   this.router.navigate(
    ['/view-details', analyticsProduct.moduleId || analyticsProduct.id]
  );
}

loadModule(analyticsProduct: any){
    this.utilService.shareSelectedAnalyticsFilters.next(this.getAppliedFilters());
    this.utilService.loadModule(analyticsProduct);
}
getAppliedFilters() {
    return {
      regionsList: this.filterForm.get('regionsList')?.value,
      businessLinesList: this.filterForm.get('businessLinesList')?.value,
      functionsList: this.filterForm.get('functionsList')?.value,
      productLinesList: this.filterForm.get('productLinesList')?.value,
      categoryList: this.filterForm.get('categoryList')?.value,
      searchText:this.searchText,
      selectedTab:this.selectedAnalyticsTab
    };
  }

  createAccessRequestForSingleGroup(module:any){
      const apiPayload = {
            submittedByUserId: this.userId,
            companyId: this.companyId,
            headerId: this.headerId,
            moduleId: module?.moduleId,
            isModuleAttached: true,
            userGroups: module?.userGroups
          };
           this.manageRequestService.createAccessRequest(apiPayload).subscribe({
            next: (response:any) => {
              if(response.code == 200){
                this.successMessage = response?.result;
                setTimeout(() => { this.successMessage = ''; }, 5000);
                this.getHeader();
              }
            },
            error: (error) => {
              this.errMsg = 'Failed to submit access request. Please try again.';
              this.showErrorMessageWithPopup = true;
              setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
            }
          });
  }

 onAccessPending() { 
    this.errMsg = `Please contact <a 
      href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
      target='_blank' 
      class='admin-email-link'>
      DMINT Administrator
    </a> to get access for the same`
      this.closeSign = 'OK';
      this.showErrorMessageWithPopup = true;
}
userDetails(){
    this.userName = localStorage.getItem('userName');
    this.utilService.companyName.subscribe((res:any) => this.companyName = res);
    this.utilService.companyId.subscribe((res:any) => this.companyId = res);
  }


onRequestAccessClick(module: any) {
  if(module.isSingleUserGroup){
    this.createAccessRequestForSingleGroup(module);
  }else{
    this.getStepOneDetails(module);
  }
}

getStepOneDetails(module: any){
    this.manageRequestService.getDataForSteps(module.moduleId).subscribe((res: any) => {
      if(res){
            this.stepOneDetails = res.result;
            this.stepOneDetails= this.stepOneDetails.sort((a:any, b:any) => a.stepNumber - b.stepNumber)
            this.callRequestPopup(module,this.stepOneDetails)
    }    
  });
} 

  callRequestPopup(module:any,stepDetails:any){
     const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: {
        module:module,
        stepDetails:stepDetails,
        title: `Request access to ${module.moduleName}`,
        panelClass: 'request-access-dialog',
        disableClose: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle business-specific data in parent component
        const apiPayload = {
          submittedByUserId: this.userId,
          companyId: this.companyId,
          headerId: this.headerId,
          moduleId: module?.moduleId,
          isModuleAttached: result?.isModuleAttached,
          userGroups: result?.userGroups
        };
   //    Submit to API
        this.manageRequestService.createAccessRequest(apiPayload).subscribe({
          next: (response:any) => {
            if(response.code == 200){
              this.successMessage = response?.result;
              setTimeout(() => { this.successMessage = ''; }, 5000);
              this.getHeader();
            }
          },
          error: (error) => {
            this.errMsg = 'Failed to submit access request. Please try again.';
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
          }
        });
      }
    });
    
  }
}
